import React from "react";
import AppModal from "./Generic/AppModal/AppModal";
import Flex from "./Generic/Flex";
import { AppButton } from "./Generic/AppButton";
import { useSpeechRecognition } from "../hooks/useSpeechRecognition";
import styled from "@emotion/styled";
import { translate } from "../translate";
import { STRINGS } from "../strings";

export function SpeechRecognitionModal(props: {
  isOpen: boolean;
  onStop: (text: string) => void;
  onCancel: () => void;
}) {
  const { listening, start, stop, currentText } = useSpeechRecognition({
    autoStart: true,
  });

  const renderContent = () => {
    if (listening) {
      return (
        <Content>
          <span>{currentText === "" ? translate(STRINGS.LISTENING___) : currentText}</span>
          <Actions>
            <ActionButton
              variant="filled"
              color="primary"
              onClick={() => {
                stop();
                props.onStop(currentText);
              }}
            >
              {translate(STRINGS.STOP)}
            </ActionButton>
          </Actions>
        </Content>
      );
    }

    return (
      <Content>
        <Actions>
          <ActionButton variant="outline" onClick={props.onCancel} color="danger">
            {translate(STRINGS.CANCEL)}
          </ActionButton>
          <ActionButton variant="outline" onClick={start}>
            {translate(STRINGS.START)}
          </ActionButton>
        </Actions>
      </Content>
    );
  };

  const content = renderContent();

  return (
    <AppModal
      isOpen={props.isOpen}
      actions={[]}
      title={translate(STRINGS.SPEECH_RECOGNITION)}
      type="neutral"
      style={{ width: "100%" }}
    >
      <Content>{content}</Content>
    </AppModal>
  );
}

const Content = styled(Flex)`
  width: 100%;
  flex-direction: column;
  gap: 8px;
`;

const Actions = styled(Flex)`
  flex-direction: row;
  gap: 8px;
  width: 100%;
  justify-items: space-between;
`;

const ActionButton = styled(AppButton)`
  flex: 1;
`;
